import { useState, useEffect, } from 'react';

/* Хук для отслеживания прокрутки страницы с порогом*/
export const useScrollThreshold = (threshold = 50): boolean => {
    const [isScrolled, setIsScrolled] = useState(false);
    useEffect(() => {
        const onScroll = () => {
            setIsScrolled(window.scrollY > threshold);
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll(); // инициализация при монтировании
        return () => window.removeEventListener('scroll', onScroll);
    }, [threshold]);
    return isScrolled;
};